import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import {
  useConsumerQuery,
  useConsumerStatusSummaryQuery,
} from 'apollo/queries/autogenerate/hooks';
import { HoukatsuStatus } from 'apollo/queries/autogenerate/schemas';
import Button from 'shared/modules/common/components/atoms/Button';
import TextInput from 'shared/modules/common/components/atoms/TextInput';
import { getSeiMei } from 'shared/utils/normalize-user-name';

type Props = {
  onEditButtonPress: () => void;
};

const UserName = (props: Props) => {
  const isHugeScreen = useMediaQuery({ minWidth: 1024 });

  const { data: consumerData } = useConsumerQuery({
    fetchPolicy: 'cache-only',
  });
  const { data: consumerStatusData } = useConsumerStatusSummaryQuery({
    fetchPolicy: 'cache-only',
  });

  const isPlus =
    consumerStatusData?.houkatsuStatus.status === HoukatsuStatus.APPROVED ||
    consumerStatusData?.houkatsuStatus.status ===
      HoukatsuStatus.APPROVED_FOR_NLP;

  const noName = !`${consumerData?.consumer.name1 || ''}${
    consumerData?.consumer.name2 || ''
  }`.trim().length;

  const [kanjiSei, kanjiMei] = getSeiMei(consumerData?.consumer.name1 || '');
  const [kanaSei, kanaMei] = getSeiMei(consumerData?.consumer.name2 || '');

  const NonEditableField = (fieldProps: { label: string; value: string }) => (
    <TextInput
      value={fieldProps.value}
      label={fieldProps.label}
      editable={false}
      style={[style.textInput, isHugeScreen && style.textInputHugeScreen]}
      inputStyle={style.textInputNativeInput}
    />
  );

  return (
    <>
      <View style={[style.title, style.row, style.rowSpaceBetween]}>
        <Text style={style.titleText}>お名前</Text>
        {!noName && !isPlus && (
          <Button
            title="編集"
            variant="outlined"
            titleStyle={style.buttonTitle}
            onPress={props.onEditButtonPress}
            style={style.editButton}
            id="edit-user-name-button"
          />
        )}
      </View>
      {noName && !isPlus && (
        <Button
          title="追加"
          onPress={props.onEditButtonPress}
          style={style.editUserNameButton}
          id="edit-empty-user-name-button"
        />
      )}
      {!noName && (
        <>
          <View style={isHugeScreen && style.row}>
            <NonEditableField value={kanjiSei} label="姓" />
            <NonEditableField value={kanjiMei} label="名" />
          </View>
          {isHugeScreen && <View style={style.separator} />}
          <View style={isHugeScreen && style.row}>
            <NonEditableField value={kanaSei} label="セイ（カタカナ）" />
            <NonEditableField value={kanaMei} label="メイ（カタカナ）" />
          </View>
        </>
      )}
    </>
  );
};

const style = StyleSheet.create({
  title: {
    marginBottom: 16,
  },
  titleText: {
    fontWeight: 'bold',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowSpaceBetween: {
    justifyContent: 'space-between',
  },
  separator: {
    height: 24,
  },
  textInput: {
    marginBottom: 12,
  },
  textInputHugeScreen: {
    width: '100%',
    maxWidth: 244,
    marginRight: 24,
    flexGrow: 0,
  },
  textInputNativeInput: {
    color: '#2A2E32',
  },
  editButton: {
    height: 32,
    width: 88,
  },
  buttonTitle: {
    fontSize: 12,
  },
  editUserNameButton: {
    alignSelf: 'center',
  },
});

export default UserName;
